// extracted by mini-css-extract-plugin
export default {"container":"container-t4NPE","profile":"profile-fZxcS","name":"name-ksr_D","email":"email-S8wBt","role":"role-QCsVa","icon":"icon-c9kJO","logout":"logout-MUJR6"};